(() => {
    let init = true

    const isTouch = document.documentElement.classList.contains('touch')

    const isDev = window.location.hostname === 'mann-web.lndo.site'
        || window.location.hostname === 'localhost'

    const mobileMax = 890

    window.gsap.registerPlugin(window.ScrollTrigger)

    window.gsap.registerPlugin(window.ScrollTo)

    function createLazyObserver (
        callback,
        offset = '25%',
        once = true
    ) {
        const offsetVal = typeof offset === 'number'
            ? `${offset}px`
            : offset

        const rootMargin = offsetVal.trim().includes(' ')
            ? offsetVal
            : `${offsetVal} 0px ${offsetVal} 0px`;

        const options = {
            rootMargin,
            threshold: 0.01
        }

        const observer = new window
            .IntersectionObserver((entries) => entries
                .forEach(entry => {
                    if (!entry.isIntersecting)
                        return

                    callback(entry)

                    if (once)
                        observer.unobserve(entry.target)
                }),
            options)

        return observer
    }

    function debounce (cb, wait = 200) {
        let timeout = null

        return (...args) => {
            window.clearTimeout(timeout)

            timeout = setTimeout(() =>
                cb.apply(null, args),
                wait)
        }
    }

    function remToPixels(rem) {
        return parseFloat(rem)
            * parseFloat(getComputedStyle(document.documentElement).fontSize);
    }

    function getOffsetTop (el) {
        return el
            ? getOffsetTop(el.offsetParent) + el.offsetTop
            : 0
    }

    function getScrollOffsetY (opts = {
        headerHeight: true,
        navbarHeight: true,
        scrollPaddingTop: true
    }) {
        const headerHeight = opts.headerHeight
            ? remToPixels(getCssVar('--header-height') || '0')
            : 0

        const utilityNavbarHeight = opts.navbarHeight
            ? remToPixels(getCssVar('--utility-navbar-height') || '0')
            : 0

        let scrollPaddingTop = opts.scrollPaddingTop
            ? parseFloat(window.getComputedStyle(
                document.documentElement).scrollPaddingTop || '0')
            : 0

        if (isNaN(scrollPaddingTop))
            scrollPaddingTop = 0

        return headerHeight
            + utilityNavbarHeight
            + scrollPaddingTop
    }

    function getDrupalOffsetTop() {
        return parseFloat(getCssVar('--drupal-displace-offset-top') || '0')
    }

    function getCssVar(name, el) {
        return name
            && window.getComputedStyle(el || document.documentElement)
                .getPropertyValue(name)
    }

    function setCssVar(name, val, el) {
        return name
            && (el || document.documentElement).style
                .setProperty(name, val || '')
    }

    function getBoundsInViewport (el, offset = {
        top: getDrupalOffsetTop(),
        bottom: 0
    }) {
        if (!el)
            return null

        const offsetTop = (offset || {}).top || 0

        const offsetBottom = (offset || {}).bottom || 0

        const bounds = el.getBoundingClientRect()

        const isTopVisible = bounds.top > offsetTop
            && bounds.top <= window.innerHeight + offsetBottom

        const isBottomVisible = bounds.bottom > offsetTop
            && bounds.bottom <= window.innerHeight + offsetBottom

        return ({
            top: isTopVisible,
            bottom: isBottomVisible,
            viewport: isTopVisible
                || isBottomVisible
                || (bounds.height > window.innerHeight
                    && bounds.top <= offsetTop
                    && bounds.bottom > window.innerHeight + offsetBottom),
            bounds
        })
    }

    function getVideos () {
        return Array.from(document.body
            .querySelectorAll('video'))
    }

    function progressBar() {
        const progressBar = document.querySelector('.progress')

        if (!progressBar)
            return

        window.addEventListener('scroll', () => {
            if (document.body.classList.contains('menu-open'))
                return

            const scrollPosition = window.scrollY
            const totalHeight = document.body.scrollHeight - window.innerHeight
            const scrollProgress = (scrollPosition / totalHeight) * 100

            if (!isNaN(scrollProgress))
                progressBar.value = scrollProgress
        })
    }

    function getGsapIntroEl () {
        return document.querySelector('.intro')
    }

    function getGsapIntroAssets () {
        const intro = getGsapIntroEl()

        return Array.from(intro
            .querySelectorAll('.intro-wrapper-content img'))
    }

    function getGsapIntroDistance () {
        return getGsapIntroAssets().length
            || 1
    }

    function getGsapIntroEnd () {
        return getGsapIntroDistance() + 3
    }

    function gsapIntro() {
        const intro = getGsapIntroEl()

        if (!intro)
            return

        // LOGO & BG Video
        const logo = intro.querySelector('.intro-wrapper-logo')
        const logoCover = intro.querySelector('.intro-cover')
        const logoSquare = logo.querySelector('.intro-logo-square')
        const bgVideo = intro.querySelector('.intro-cover video')

        // CONTENT
        const content = intro.querySelector('.intro-wrapper-content')
        const assetsWrapper = content.querySelector('.intro-content-assets')
        const assets = getGsapIntroAssets()
        const distance = getGsapIntroDistance()
        const end = getGsapIntroEnd()

        const header = document.getElementById('header')
        const titles = Array.from(content.querySelectorAll('.intro-content-title'))
        const video = content.querySelector('.intro-video video')

        // Init height calculation to avoid jumps on load
        document.body.style.minHeight = `${window.innerHeight * end
            + document.body.clientHeight}px`

        const onEnter = () => {
            if (bgVideo
                    && bgVideo.paused
                    && !bgVideo.getAttribute('data-suspended'))
            bgVideo.play()
                .catch(err => {
                    if (isDev)
                        console.warn(err)

                    bgVideo.setAttribute('data-suspended', true)

                    bgVideo.src = (bgVideo.src || '')
                        .replace(/#t=.+$/, '#t=3')

                    bgVideo.load()
                })

            if (video
                    && video.paused)
                video.play()
                    .catch(err => isDev
                        && console.warn(err))
        }

        const tl = window.gsap.timeline({
            scrollTrigger: {
                trigger: intro,
                // Start when the section reaches the top of viewport
                start: 'top top',
                scrub: 1.5,
                // End the scroll animation based on the number of assets
                end: `${end * 100}% bottom`,
                pin: true,
                pinSpacing: true,
                invalidateOnRefresh: true,
                onUpdate: (self) => {
                    const direction = self.direction != -1
                        ? 'down'
                        : 'up'

                    let assetIndex = parseInt(((distance + 1)
                        * self.progress * 2) - (distance - 12))

                    if (assetIndex < 1)
                        assetIndex = 0

                    if (assetIndex > distance)
                        assetIndex = distance

                    if (assetIndex)
                        assets
                            .forEach((asset, idx) => {
                                if (!idx)
                                    return

                                let display

                                if (direction === 'down')
                                    display = idx <= assetIndex
                                        ? 'block'
                                        : 'none'

                                if (direction === 'up')
                                    display = idx < assetIndex
                                        ? 'block'
                                        : 'none'

                                // Avoid unneccesary paints
                                if (asset.style.display !== display)
                                    asset.style.display = display
                            })

                    const assetsBounds = assetsWrapper.getBoundingClientRect()

                    const offsetTop = getDrupalOffsetTop()

                    const isAssetsTopVisible = assetsBounds.top > offsetTop
                        && assetsBounds.top <= window.innerHeight

                    const isAssetsBottomVisible = assetsBounds.bottom > offsetTop
                        && assetsBounds.bottom <= window.innerHeight

                    const isAssetsVisible = isAssetsTopVisible
                        || isAssetsBottomVisible
                        || (assetsBounds.top <= offsetTop
                            && assetsBounds.bottom > window.innerHeight)

                    if (isAssetsVisible
                            && header.classList.contains('sticky--force-visible'))
                        header.classList.remove('sticky--force-visible')

                    if (isAssetsVisible
                            && !header.classList.contains('sticky--force-hidden'))
                        header.classList.add('sticky--force-hidden')

                    if (!isAssetsVisible
                            && header.classList.contains('sticky--force-hidden'))
                        header.classList.remove('sticky--force-hidden')

                    if (!isAssetsVisible
                            && !header.classList.contains('sticky--force-visible')
                            && self.isActive)
                        header.classList.add('sticky--force-visible')
                },
                onEnter,
                onEnterBack: onEnter,
                onLeave: () => {
                    assets.forEach(asset => {  asset.style.display = 'block' })
                    header.classList.remove('sticky--force-visible')

                    if (bgVideo
                            && !bgVideo.paused)
                        bgVideo.pause()

                    if (video
                            && !video.paused)
                        video.pause()
                }
            }
        })


        tl
            .set(logo, {
                left: 0,
                position: 'absolute'
            })
            .set(titles, { autoAlpha: 0 })
            .set(assetsWrapper, {
                autoAlpha: 0,
                width: '300px',
                height: '300px',
            })
            .to(logoSquare, {
                duration: 0.05,
                height : '300px',
                width: '300px',
                ease: 'power1.in',
                autoAlpha: 1
            }, '<')
            .to(assetsWrapper, {
                duration: 0.1,
                autoAlpha: 1
            }, '>')
            .to(titles[0], {
                duration: 0.1,
                autoAlpha: 1
            })
            .to(assetsWrapper, {
                width: '525px',
                height: '525px',
                ease: 'linear'
            })
            .to(logoCover, {
                duration: 0.1,
                autoAlpha: 0
            }, '<')
            .to(assetsWrapper, {
                width: '100vw',
                height: '100vh',
                ease: 'linear',
                onComplete: () => video
                    && !video.paused
                    && (video.currentTime = 0)
            })
            .to(logo, {
                duration: 0.1,
                autoAlpha: 0,
            }, '<')
            .to(titles[1], {
                duration: 0.1,
                autoAlpha: 1
            }, '<45%')
            .to(assetsWrapper, {
                duration: 0.1,
                position: 'fixed',
                y: '-110vh',
                onStart() {
                    content.classList.add('is-complete')
                },
                onReverseComplete() {
                    content.classList.remove('is-complete')
                }
            })
            .to(titles, {
                duration: 0.2,
                y: '-100vh',
                delay: 0.25
            })
    }

    function gsapTimeline() {
        const els = window.gsap.utils.toArray('.timeline')

        return els.forEach((el, i) => {
            const headerEl = el.querySelector('.timeline-header')

            const contentEl = el.querySelector('.timeline-content')

            const asideEl = el.querySelector('.timeline-content aside')

            const sidebarEl = el.querySelector('.timeline-content-sidebar')

            const sidebarLinks = window.gsap.utils.toArray(el
                .querySelectorAll('.timeline-content-sidebar li a'))

            const decadesEls = window.gsap.utils.toArray(el
                .querySelectorAll('.timeline-content-main:not(.timeline-content-results)'))

            const results = el.querySelector('.timeline-content-results')

            const resultsList = results
                && results.querySelector('ul')

            const expandedToggles = el
                .querySelector('.timeline-expanded-toggles')

            const expandedTogglesGroup = expandedToggles
                && expandedToggles
                    .querySelector('.timeline-expanded-toggles-group')

            const expandedTogglesRadios = expandedToggles
                && window.gsap.utils.toArray(expandedToggles
                    .querySelectorAll('input[type=radio]'))

            const filters = el.querySelector('nav.filters')

            const getCollapsibles = () => window.gsap.utils.toArray(el
                .querySelectorAll('.timeline-content-main-item-collapse'))

            const getActiveCollapsibles = () => {
                const isFilter = contentEl.getAttribute('data-filter')

                return getCollapsibles()
                    .filter(collapsible => (isFilter
                            && resultsList
                            && resultsList.contains(collapsible))
                        || (!isFilter
                            && resultsList
                            && !resultsList.contains(collapsible)))
            }

            const getItems = () => window.gsap.utils.toArray(
                el.querySelectorAll('.timeline-content-main-item'))

            const setLinks = (i) => !document.documentElement
                    .getAttribute('data-resizing')
                && sidebarLinks
                    .forEach((link, idx) => {
                        const getAriaCurrent = () => link
                            .getAttribute('aria-current')

                        const isAriaCurrent = () => getAriaCurrent()
                            === 'true'

                        const isAriaCurrentChange = (!getAriaCurrent
                            || (isAriaCurrent()
                                && i !== idx)
                            || (!isAriaCurrent()
                                && i === idx))

                        const setAriaCurrent = () => isAriaCurrent
                            && link.setAttribute('aria-current', i === idx)

                        setAriaCurrent()

                        if (isAriaCurrentChange)
                            link.scrollIntoView({ behavior: 'smooth', inline: 'nearest' })
                    })

            const setHeaderState = () => {
                const coverVideo = headerEl
                    .querySelector('video')

                const bounds = getBoundsInViewport(headerEl)

                const isActive = bounds.viewport

                if (coverVideo
                        && isActive
                        && coverVideo.paused
                        && !coverVideo.getAttribute('data-suspended'))
                    coverVideo.play()
                        .catch(err => {
                            isDev
                                && console.warn(err)

                            if (!/50th-anniversary-intro.mp4.*$/
                                    .test(coverVideo.src))
                                return

                            coverVideo
                                .setAttribute('data-suspended', true)

                            coverVideo.src = (coverVideo.src || '')
                                .replace(/#t=.+$/, '#t=3')

                            coverVideo.load()
                        })

                if (coverVideo
                        && !isActive
                        && !coverVideo.paused)
                    coverVideo.pause()

                if ((isActive
                            && !headerEl.classList.contains('active'))
                        || (!isActive
                            && headerEl.classList.contains('active')))
                    headerEl.classList.toggle('active')
            }

            setHeaderState()

            const onFiltersChange = (target, slug, value) => {
                const radioOff = (expandedTogglesRadios || [])
                    .filter(radio => radio.value === 'off')[0]

                if (!value) {
                    if (asideEl
                            && asideEl
                                .getAttribute('aria-hidden'))
                       asideEl
                            .removeAttribute('aria-hidden')

                    if (resultsList)
                        resultsList.innerHTML = ''

                    if (contentEl
                            && contentEl.getAttribute('data-filter'))
                        contentEl.removeAttribute('data-filter')
                }

                if (value) {
                    if (asideEl
                            && asideEl
                                .getAttribute('aria-hidden') !== 'true')
                        asideEl
                            .setAttribute('aria-hidden', true)

                    if (contentEl
                            && !contentEl.getAttribute('data-filter'))
                        contentEl.setAttribute('data-filter', value)
                }

                if (radioOff
                        && !radioOff.checked) {
                    getCollapsibles()
                        .forEach(collapsible =>
                            (collapsible.style.transition = 'none'))

                    radioOff.click()

                    getCollapsibles()
                        .forEach(collapsible =>
                            (collapsible.style.transition = ''))
                }

                if (value)
                    getItems()
                        .forEach((item) => {
                            const isDisabled = value
                                && item.getAttribute(`data-${value}`)
                                    !== slug

                            if (isDisabled)
                                return

                            const clone = item.cloneNode(true)

                            const idEls = window.gsap.utils.toArray(
                                clone.querySelectorAll('[id]'))

                            idEls
                                .forEach((idEl) => {
                                    const { id } = idEl

                                    const cloneId = `${id}-clone`

                                    const controls = window.gsap.utils.toArray(
                                        idEl.querySelectorAll(
                                            `[aria-controls="${id}"]`))

                                    controls
                                        .forEach((control) => {
                                            control.setAttribute('aria-controls', cloneId)

                                            if (control.getAttribute('data-bs-target'))
                                                control
                                                    .setAttribute(
                                                        'data-bs-target',
                                                        `#${cloneId}`)
                                        })
                                })

                            if (resultsList)
                                resultsList.appendChild(clone)
                        })

                window.ScrollTrigger.refresh()
            }

            if (filters)
                filters.addEventListener('change', (e) => {
                    const { target } = e

                    const slug = target
                        && target.name

                    let { value } = target || {}

                    if (/(radio|checkbox)/.test(target.type)
                            && !target.checked)
                        value = ''

                    if (!slug)
                        return

                    el.setAttribute('data-filtering', true)

                    const filterTl = window.gsap.timeline()

                    const header = document.getElementById('header')

                    const hashchangeId = !value
                        && el.getAttribute('data-hashchange')

                    const hashchangeEl = hashchangeId
                        && document.getElementById(hashchangeId)

                    filterTl
                        .to(contentEl, {
                            opacity: 0,
                            delay: 0.1,
                            duration: 0.3,
                            onComplete: () => {
                                el.style.minHeight = `${el.clientHeight}px`

                                onFiltersChange(target, slug, value)
                            }
                        })
                        .to(window, (() => {
                            if (header)
                                header.classList.add('sticky--force-hidden')

                            const scrollTo = getOffsetTop(contentEl) + 1

                            return ({
                                scrollTo,
                                onComplete: () => {
                                    el.removeAttribute('data-filtering')

                                    el.style.minHeight = ''

                                    setTimeout(() =>
                                        !hashchangeEl
                                            && header
                                            && header.classList
                                                .remove('sticky--force-hidden'),
                                        17)
                                }
                            })
                        })())
                        .to(contentEl, {
                            opacity: 1,
                            duration: 0.6,
                            onComplete: () => {
                                if (!hashchangeEl)
                                    return

                                const scrollTo = getOffsetTop(hashchangeEl) + 1

                                window.gsap.to(window, {
                                    scrollTo,
                                    onComplete: () => {
                                        setTimeout(() => {
                                            if (header)
                                                header.classList
                                                    .remove('sticky--force-hidden')

                                            el.removeAttribute('data-hashchange')

                                            hashchangeEl
                                                .focus({ preventScroll: true })
                                        }, 17)
                                    }
                                })
                            }
                        })
                })

            const onCollapseToggle = (e) => {
                if (!expandedTogglesRadios)
                    return

                const collapsibles = getActiveCollapsibles()

                const expanded = collapsibles
                    .filter(collapsible => collapsible.classList
                        .contains('show'))

                const collapsed = collapsibles
                    .filter(collapsible => !collapsible.classList
                        .contains('show'))

                const isAllExpanded = expanded.length === collapsibles.length

                const isAllCollapsed = collapsed.length === collapsibles.length

                const isAllBoth = expanded.length
                    && collapsed.length

                const radioChecked = expandedTogglesRadios
                    .filter(radio => radio.checked)[0]

                const radioOn = expandedTogglesRadios
                    .filter(radio => radio.value === 'on')[0]

                const radioOff = expandedTogglesRadios
                    .filter(radio => radio.value === 'off')[0]

                if (isAllBoth
                        && radioChecked)
                    radioChecked.checked = false

                if (isAllExpanded
                        && !radioOn.checked)
                    radioOn.checked = true

                if (isAllCollapsed
                        && !radioOff.checked)
                    radioOff.checked = true

                if (!el.getAttribute('data-expanding'))
                    window.ScrollTrigger.refresh()
            }

            const onCollapseHide = (e) => {
                const { previousElementSibling } = e.target

                setCssVar(
                    '--timeline-item-media-caption-translateY',
                    '',
                    previousElementSibling)
            }

            const onCollapseShow = (e) => {
                const { previousElementSibling } = e.target

                const media = previousElementSibling
                    .querySelector('.timeline-content-main-item-col-media')

                if (media)
                    setCssVar(
                        '--timeline-item-media-caption-translateY',
                        `${((media.clientHeight * 1.6667)
                            - media.clientHeight)
                            * -1}px`,
                        previousElementSibling)
            }

            const setCollapseListeners = () => getCollapsibles()
                .forEach((collapsible) => {
                    collapsible
                        .removeEventListener('hide.bs.collapse', onCollapseHide)

                    collapsible
                        .addEventListener('hide.bs.collapse', onCollapseHide)

                    collapsible
                        .removeEventListener('show.bs.collapse', onCollapseShow)

                    collapsible
                        .addEventListener('show.bs.collapse', onCollapseShow)

                    collapsible
                        .removeEventListener('hidden.bs.collapse', onCollapseToggle)

                    collapsible
                        .addEventListener('hidden.bs.collapse', onCollapseToggle)

                    collapsible
                        .removeEventListener('shown.bs.collapse', onCollapseToggle)

                    collapsible
                        .addEventListener('shown.bs.collapse', onCollapseToggle)
                })

            setCollapseListeners()

            if (expandedToggles)
                expandedToggles
                    .addEventListener('change', (e) => {
                        el.setAttribute('data-expanding', true);

                        const header = document.getElementById('header')

                        if (header)
                            header.classList.add('sticky--force-hidden')

                        const scrollTo = getOffsetTop(contentEl) + 1

                        const method = e.target.value === 'on'
                            ? 'show'
                            : 'hide'

                        window.gsap.to(window, {
                            scrollTo,
                            onComplete: () => {
                                setCollapseListeners()

                                getActiveCollapsibles()
                                    .sort((a, b) => {
                                        const is_active_a = a.parentElement
                                            .classList
                                            .contains('active')

                                        const is_active_b = b.parentElement
                                            .classList
                                            .contains('active')

                                        if (is_active_a && is_active_b)
                                            return 0

                                        return is_active_a
                                            ? -1
                                            : 1
                                    })
                                    .forEach(item => {
                                        const collapse = window.bootstrap.Collapse
                                            .getOrCreateInstance(item, {
                                                toggle: false
                                            })

                                        collapse[method]()
                                    })

                                setTimeout(() => {
                                    if (header)
                                        header.classList
                                            .remove('sticky--force-hidden')

                                    el.removeAttribute('data-expanding')

                                    window.ScrollTrigger.refresh()
                                }, method === 'show'
                                    ? 300
                                    : 17)
                            }
                        })
                    })

            if (expandedToggles
                    && expandedTogglesGroup)
                expandedToggles._scrollTrigger = window.ScrollTrigger
                    .create({
                        trigger: expandedToggles,
                        startTrigger: contentEl,
                        start: 'top top',
                        endTrigger: contentEl,
                        end: 'bottom top',
                        toggleClass: 'active',
                        invalidateOnRefresh: true,
                        pin: expandedTogglesGroup,
                        pinSpacing: false
                    })

            const onDecadeEnter = (decade, i) => {
                if (contentEl.getAttribute('data-filter'))
                    return

                const color = getCssVar('--tmh-timeline-color', decade)

                if (getCssVar('--tmh-timeline-active-color', el)
                        !== color)
                    setCssVar('--tmh-timeline-active-color', color, el)

                setLinks(i)
            }

            decadesEls
                .forEach((decade, i) =>
                    decade._scrollTrigger = window.ScrollTrigger
                        .create({
                            trigger: decade,
                            start: `top ${i
                                ? '25%'
                                : 'top'}`,
                            end: `bottom ${i + 1 === decadesEls.length
                                ? 'top'
                                : '25%'}`,
                            toggleClass: 'active',
                            invalidateOnRefresh: true,
                            onEnter: () => onDecadeEnter(decade, i),
                            onEnterBack: () => onDecadeEnter(decade, i)
                        }))

            window.gsap.matchMedia().add(`(min-width: ${mobileMax}px)`, () => {
                if (asideEl)
                    asideEl._scrollTrigger = window.ScrollTrigger
                        .create({
                            trigger: asideEl,
                            start: 'top top',
                            end: 'bottom top',
                            toggleClass: 'active',
                            invalidateOnRefresh: true,
                            pin: sidebarEl,
                            pinSpacing: false
                        })
            })

            const onHashChange = (e) => {
                const id = window.location.hash.length > 1
                    && window.location.hash
                        .substring(1)

                const scrollToEl = id
                    && document.getElementById(id)

                if (!scrollToEl
                        || !el.contains(scrollToEl)
                        || !window.history)
                    return

                window.history.replaceState(
                    null,
                    null,
                    window.location.href.replace(window.location.hash, ''))
            }

            onHashChange()

            el.addEventListener('click', (e) => {
                const href = e.target
                    && e.target.getAttribute('href')

                const id = (href || '').match(/^#/)
                    && href.substring(1)

                const scrollToEl = id
                    && document.getElementById(id)

                if (!scrollToEl)
                    return

                e.preventDefault()
                e.stopPropagation()

                el.setAttribute('data-hashchange', id)

                if (contentEl.getAttribute('data-filter')) {
                    const clearBtn = filters.querySelector('.filters-group-clear')

                    if (clearBtn)
                        clearBtn.click()

                    return
                }

                const header = document.getElementById('header')

                if (header)
                    header.classList.add('sticky--force-hidden')

                const scrollTo = getOffsetTop(scrollToEl) + 1

                window.gsap.to(window, {
                    scrollTo,
                    onComplete: () => {
                        setTimeout(() => {
                            if (header)
                                header.classList
                                    .remove('sticky--force-hidden')

                            el.removeAttribute('data-hashchange')

                            scrollToEl.focus({ preventScroll: true })
                        }, 17)
                    }
                })
            })

            window.addEventListener('hashchange', onHashChange)

            window.addEventListener('scroll', setHeaderState)

            window.addEventListener('resize', setHeaderState)

            window.addEventListener('resize',
                debounce(() =>
                    window.ScrollTrigger.refresh(),
                    400))
        })
    }

    function gsapMoments() {
        const {
            documentElement: root,
            body
        } = document

        const els = window.gsap.utils.toArray('.moments')

        const calcPos = (element, ) => {
            const rect = element
                .getBoundingClientRect()

            const scrollLeft = window.pageXOffset
                || root.scrollLeft
                || body.scrollLeft
                || 0

            const clientLeft = root.clientLeft
                || body.clientLeft
                || 0

            const left = Math.round(rect.left + scrollLeft - clientLeft)

            return {
                top: rect.top,
                left,
                height: rect.height,
                width: rect.width
            }
        }

        els.forEach((el, i) => {
            const filters = el.querySelector('nav.filters')

            const statementXl = el.querySelector('.statement-xl')

            const statementXlWrapper = statementXl
                && statementXl.querySelector('.statement-wrapper')

            const statementXlVideo = statementXl
                && statementXl.querySelector('video')

            const statementXlTl = statementXl
                && window.gsap.timeline({
                    scrollTrigger: {
                        toggleActions: 'play pause reverse reset',
                        trigger: statementXl,
                        start: 'top top',
                        end: 'bottom top',
                        pin: statementXlWrapper,
                        invalidateOnRefresh: true,
                        scrub: true,
                        onUpdate: (self) => {
                            if (!statementXlVideo)
                                return

                            if (statementXlWrapper.style.position === 'fixed'
                                    && !statementXlVideo.classList
                                        .contains('position-fixed'))
                                statementXlVideo.classList
                                    .add('position-fixed')

                            if ((statementXlWrapper.style.position !== 'fixed'
                                        || !self.isActive)
                                    && self.progress < 1
                                    && statementXlVideo.classList
                                        .contains('position-fixed'))
                                statementXlVideo.classList
                                    .remove('position-fixed')

                            if ((self.progress === 1
                                        && !statementXlVideo.classList
                                            .contains('complete'))
                                    || (self.progress < 1
                                        && statementXlVideo.classList
                                            .contains('complete')))
                                statementXlVideo.classList
                                    .toggle('complete')
                        }
                    }
                })

            if (statementXlTl
                    && statementXlWrapper)
                statementXlTl.to(statementXlWrapper, {
                    delay: 0.2,
                    autoAlpha: 0
                })

            const setStatementXlVideoState = (isActive) => {
                if (!statementXlVideo)
                    return

                if ((isActive
                            && !statementXlVideo.classList.contains('active'))
                        || (!isActive
                            && statementXlVideo.classList.contains('active')))
                    statementXlVideo.classList.toggle('active')

                if (isActive
                        && statementXlVideo.paused
                        && !statementXlVideo.getAttribute('data-suspended'))
                    statementXlVideo.play()
                        .catch(err => {
                            if (isDev)
                                console.warn(err)

                            if (!/50th-anniversary-intro.mp4.*$/
                                    .test(statementXlVideo.src))
                                return

                            statementXlVideo
                                .setAttribute('data-suspended', true)

                            statementXlVideo.src = (statementXlVideo.src || '')
                                .replace(/#t=.+$/, '#t=3')

                            statementXlVideo.load()
                        })

                if (!isActive
                        && !statementXlVideo.paused)
                    statementXlVideo.pause()
            }

            const setState = () => {
                if (!statementXl)
                    return

                const isActive = getBoundsInViewport(statementXl).viewport

                setStatementXlVideoState(isActive)
            }

            setState()

            window.addEventListener('scroll', setState)

            window.addEventListener('resize', setState)

            const positionResultsItem = (item) => {
                const resultsWrapperId = item
                    && `${item.id}-results-item-wrapper`

                const resultsWrapper = resultsWrapperId
                    && document.getElementById(resultsWrapperId)

                if (!resultsWrapper)
                    return item
                        && item.getAttribute('style')
                        && item.removeAttribute('style')

                const resultsPosition = calcPos(resultsWrapper)

                const scrollOffsetY = getScrollOffsetY()

                resultsPosition.top = getOffsetTop(resultsWrapper)
                    - scrollOffsetY

                window.gsap.set(item, {
                    ...resultsPosition,
                    position: 'absolute'
                })

                const isSmallViewport = window.innerWidth < 686

                let resultsIdx = window.gsap.utils.toArray(
                        resultsWrapper.parentElement.parentElement.children)
                    .indexOf(resultsWrapper.parentElement)

                if (!isSmallViewport)
                   resultsIdx += 1

                let transformOrigin = ''

                if (isSmallViewport)
                    transformOrigin = resultsIdx % 2 === 0
                        ? 'right'
                        : 'left'

                if (!isSmallViewport)
                    transformOrigin = 'center'

                if (!isSmallViewport
                        && resultsIdx % 3 === 0)
                    transformOrigin = 'right'

                if (!isSmallViewport
                        && resultsIdx % (2 + 1) === 1)
                    transformOrigin = 'left'

                if (transformOrigin)
                    item.style.transformOrigin = `${transformOrigin} center`
            }

            const onFiltersChange = (target, slug, value) => {
                if (!target
                        || !slug)
                    return

                const container = el
                    .querySelector('.moments-container-results')

                const containerRow = container
                    && container.querySelector('.row')

                if (!containerRow)
                    return

                containerRow.innerHTML = ''

                items
                    .forEach((item) => {
                        const resultsWrapperId = `${item.id}-results-item-wrapper`

                        const resultsWrapper = document
                            .getElementById(resultsWrapperId)

                        const isDisabled = value
                            && item.getAttribute(`data-${value}`)
                                !== slug

                        if (isDisabled
                                && item.getAttribute('aria-disabled')
                                    !== 'true')
                            item.setAttribute('aria-disabled', true)

                        if (!isDisabled) {
                            if (item.getAttribute('aria-disabled'))
                                item.removeAttribute('aria-disabled')

                            if (resultsWrapper
                                    || !value)
                                return

                            const col = document.createElement('div')

                            col.className = 'col-6 col-sm-3'

                            col.innerHTML = `<div id="${
                                resultsWrapperId
                            }" class="moments-item-wrapper"></div>`

                            containerRow.appendChild(col)
                        }
                    })

                items.forEach(positionResultsItem)

                window.ScrollTrigger.refresh()
            }

            if (filters)
                filters.addEventListener('change', (e) => {
                    const { target } = e

                    const slug = target
                        && target.name

                    let { value } = target || {}

                    if (/(radio|checkbox)/.test(target.type)
                            && !target.checked)
                        value = ''

                    if (!slug)
                        return

                    el.setAttribute('data-filtering', true)

                    const sections = window.gsap.utils.toArray(
                        el.querySelectorAll([
                            '.moments-container',
                            '.moments-description'
                        ].join(',')))

                    const filterTl = gsap.timeline()

                    filterTl
                        .to(sections, {
                            opacity: 0,
                            delay: 0.1,
                            duration: 0.3,
                            onComplete: () => {
                                el.style.minHeight = `${el.clientHeight}px`
                                onFiltersChange(target, slug, value)
                            }
                        })
                        .to(window, (() => {
                            const y = getOffsetTop(filters)

                            let paddingTop = value
                                ? remToPixels(getCssVar('--moments-padding', el))
                                : 0

                            if (isNaN(paddingTop))
                                paddingTop = 0

                            const offsetY = paddingTop
                                + getScrollOffsetY({
                                    headerHeight: window.scrollY > y,
                                    scrollPaddingTop: true
                                })

                            return ({
                                scrollTo: {
                                    y,
                                    offsetY
                                },
                                onComplete: () => {
                                    el.removeAttribute('data-filtering')
                                    el.style.minHeight = ''
                                }
                            })
                        })())
                        .to(sections, {
                            opacity: 1,
                            duration: 0.6
                        })
                })

            const items = window.gsap.utils.toArray('.moments-item')

            window.addEventListener('resize', () => {
                items.forEach(positionResultsItem)

                window.ScrollTrigger.refresh()
            })

            items
                .forEach((item) => {
                    const loadIframe = async (iframe) => {
                        if (!iframe
                                || !iframe.getAttribute('data-src'))
                            return

                        item.classList.remove('ready')

                        iframe.src = iframe.getAttribute('data-src')

                        iframe.removeAttribute('data-src')

                        if (statementXlVideo
                                && statementXlVideo.getAttribute('data-suspended')
                                    === 'true')
                            item.classList.add('ready')

                        const player = new window.Vimeo.Player(iframe)

                        await player.setAutopause(false)
                            .catch(err => console.warn(err))

                        const onPlaying = async (e) => {
                            player.off('playing', onPlaying)

                            if (item.getAttribute('data-autoplay') !== 'true') {
                                const previewTime = parseFloat(item
                                    .getAttribute('data-preview-time') || '0')

                                await player.pause()
                                    .catch(err => console.warn(err))

                                await player.setCurrentTime(previewTime)
                                    .catch(err => console.warn(err))
                            }

                            if (item.classList.contains('error'))
                                item.classList.remove('error')

                            item.classList.add('ready')
                        }

                        player.on('playing', onPlaying)

                        player.on('error', (err) => {
                            console.warn(err)

                            player.destroy()

                            item.classList.add('error')

                            item.classList.remove('ready')

                            if (iframe.src)
                                iframe.setAttribute('data-src', iframe.src)

                            loadIframe(iframe)
                        })
                    }

                    const loadThumbnail = (thumbnail) => {
                        if (!thumbnail
                                || !thumbnail.getAttribute('data-src'))
                            return

                        const loader = new window.Image

                        loader.onload = () => {
                            thumbnail.src = loader.src
                            thumbnail.removeAttribute('data-src')
                            item.classList.add('ready')
                        }

                        loader.src = thumbnail.getAttribute('data-src')
                    }

                    const onLoad = (entries) => {
                        loadIframe(item
                                .querySelector('iframe[data-src]'))

                        loadThumbnail(item
                            .querySelector('img[data-src]'))
                    }

                    const observer = createLazyObserver(onLoad,
                        item.querySelector('iframe[data-src]')
                            ? '125%'
                            :  0)

                    observer.observe(item)
                })

            const modal = el.querySelector('.modal')

            modal.addEventListener('shown.bs.modal', async (e) => {
                const origin = e.relatedTarget

                window.gsap.set(modal, {
                    opacity: 0
                })

                const modalContent = e.target.querySelector('.modal-content')

                const itemModalContent = origin
                    .querySelector('.moments-item-modal-content')

                modalContent.innerHTML = (itemModalContent || {}).innerHTML || ''

                const modalPlayer = new window.Vimeo.Player(
                    modal.querySelector('[data-vimeo-id]'))

                const modalBody = e.target
                    .querySelector('.modal-body')

                const originPosition = calcPos(origin)

                const bodyPosition = calcPos(modalBody)

                window.gsap.set(origin, {
                    ...originPosition,
                    position: 'fixed',
                    margin: 0,
                    zIndex: 1060
                })

                origin.classList.add('active')

                window.gsap.to(origin, 0.3, {
                    ...bodyPosition,
                    ease: 'power2.easeInOut'
                })

                window.gsap.to(origin, {
                    opacity: 0,
                    delay: 0.3,
                    zIndex: 3
                })

                window.gsap.to(modal, {
                    opacity: 1,
                    delay: 0.3,
                    onComplete: async () =>
                        await modalPlayer.play()
                            .catch((err) => console.warn(err))
                })

                modalPlayer.on('ended', async (evt) => {
                    await modalPlayer.setCurrentTime(0)
                })
            })

            modal.addEventListener('hide.bs.modal', async (e) => {
                const item = document.querySelector('.moments-item.active')

                const resultsWrapperId = `${item.id}-results-item-wrapper`

                const resultsWrapper = document
                    .getElementById(resultsWrapperId)

                const positionEl = resultsWrapper
                    || item.parentElement

                const position = calcPos(resultsWrapper || item.parentElement)

                window.gsap.set(item, {
                    opacity: 1
                })

                window.gsap.to(item, 0.3, {
                    ...position,
                    ease: 'power2.easeInOut',
                    zIndex: 3,
                    onComplete: () => {
                        if (!isTouch
                            && el.querySelector('.moments-item-wrapper:hover')
                                === positionEl)
                            item.style.transform = 'scale(1.2)'

                        item.classList.remove('active')

                        item.style.transform = ''

                        resultsWrapper
                            ? positionResultsItem(item)
                            : item.removeAttribute('style')
                    }
                })

                const modalPlayer = new window.Vimeo.Player(
                    modal.querySelector('[data-vimeo-id] iframe'))

                await modalPlayer.destroy()
                    .catch(err => console.warn(err))

                const modalContent = e.target.querySelector('.modal-content')

                modalContent.innerHTML = ''
            })
        })
    }

    function gsapStatement() {
        const els = window.gsap.utils.toArray('.statement')
            .filter(el => !el.parentElement.classList.contains('moments'))

        const videoWrapper = els.filter(e => e
            .querySelector('.statement-video'))[0]

        const video = videoWrapper
            && videoWrapper.querySelector('video')

        if (!els)
            return

        if (videoWrapper) {
            window.gsap.set(videoWrapper, {
                opacity: 0
            })
        }

        const isLanding =  document.body.classList
            .contains('page-type-50th-anniversary-landing-page')

        els.forEach((el, i) => {
            const onUpdate = () => {
                const bounds = getBoundsInViewport(el)

                const isActive = bounds.viewport
                    || (!bounds.viewport
                        && el.contains(videoWrapper)
                        && el.nextElementSibling
                        && el.nextElementSibling.classList
                            .contains('statement-xl')
                        && getBoundsInViewport(el.nextElementSibling)
                            .viewport)

                if (video
                        && isActive
                        && video.paused
                        && !video.getAttribute('data-suspended'))
                            video.play()
                                .catch(err => {
                                    if (isDev)
                                        console.warn(err)

                                    if (!/50th-anniversary-intro.mp4.*$/
                                            .test(video.src))
                                        return

                                    video
                                        .setAttribute('data-suspended', true)

                                    video.src = (video.src || '')
                                        .replace(/#t=.+$/, '#t=3')

                                    video.load()
                                })

                if ((isActive
                            && !el.classList.contains('active'))
                        || (!isActive
                            && el.classList.contains('active')))
                    el.classList.toggle('active')
            }

            window.ScrollTrigger.create({
                el: document.body,
                invalidateOnRefresh: true,
                onUpdate
            })

            const tl = window.gsap.timeline({
                scrollTrigger: {
                    trigger: el,
                    start: 'top bottom',
                    scrub: 1,
                    invalidateOnRefresh: true,
                    onUpdate
                },
            })

            if (videoWrapper && !i) {
                if (video
                        && video.paused)
                    video.play()
                        .catch(err => isDev
                            && console.warn(err))

                tl.to(videoWrapper, {
                    duration: 0.1,
                    opacity: 1
                }, '=-100')
            }

            if ((i + 1) === els.length && videoWrapper) {
                tl.to(videoWrapper, {
                    opacity: 0,
                    onComplete: () => video
                        && !video.paused
                        && video.pause()
                }, '=+100')
            }
        })
    }

    function gsapBooks() {
        const books =  window.gsap.utils.toArray('.chapter')

        return books
            .map((book, bookIdx) => window.gsap.utils.toArray(
                book
                    .querySelectorAll('.chapter-card'))
                    .map((chapter, idx, arr) => {
                        const offsetTop = getDrupalOffsetTop()

                        const screenHeight = window.innerHeight - offsetTop

                        const isLast = idx + 1 === arr.length

                        const wrapper = chapter
                            .querySelector('.chapter-card-wrapper')

                        const bg = chapter
                            .querySelector('.chapter-card-bg')

                        const cover = chapter
                            .querySelector('.chapter-card-cover')

                        const coverVideo = cover
                            && cover.querySelector('video')

                        const borders = Array
                            .from(chapter.querySelectorAll('.chapter-card-border'))

                        const assets = chapter
                            .querySelector('.chapter-card-assets')

                        const videos = Array.from(chapter
                            .querySelectorAll('video'))

                        const content = chapter.querySelector('.chapter-card-content')

                        const text = chapter.querySelector('.chapter-card-text')

                        const title = chapter.querySelector('.chapter-card-title')

                        const captionToggle = chapter
                            .querySelector('.btn.chapter-card-captions-toggle')

                        const isSmallViewport = content.clientWidth
                            === content.parentElement.parentElement.parentElement
                                .clientWidth

                        const isIOS = /iPhone/.test(window.navigator.userAgent)

                        const fix = (el) => el
                            && !el.classList.contains('position-fixed')
                            && el.classList.add('position-fixed')

                        const unfix = (el) => el
                            && el.classList.contains('position-fixed')
                            && el.classList.remove('position-fixed')

                        const setBorders = () => {
                            const { bottom, viewport, bounds }
                                = getBoundsInViewport(wrapper)

                            const bgComputedStyle = (bg
                                && window.getComputedStyle(bg)) || {}

                            const isBgFixedVisible = bgComputedStyle.opacity === '1'
                                && bgComputedStyle.position === 'fixed'

                            const coverComputedStyle = (cover
                                && window.getComputedStyle(cover)) || {}

                            const coverMatrix = (cover
                                && new window.DOMMatrixReadOnly(
                                    coverComputedStyle.transform)) || { a: 1 }

                            const isCoverFixedVisible = coverMatrix.a === 1

                            borders
                                .forEach((border) => {
                                    const isBorderBottom = border.classList
                                        .contains('chapter-card-border-bottom')

                                    const isBorderTop = border.classList
                                        .contains('chapter-card-border-top')

                                    let display = viewport
                                            && isBgFixedVisible
                                            && isCoverFixedVisible
                                        ? 'block'
                                        : 'none'

                                    if (isLast
                                            && isBorderBottom
                                            && bottom)
                                        display = 'none'

                                    if (border.style.display !== display)
                                        border.style.display = display

                                    if (isLast
                                            && isBorderTop) {
                                        const toggleClass = 'unpin'

                                        if ((!bottom
                                                    && border.classList
                                                        .contains(toggleClass))
                                                || (bottom
                                                    && !border.classList
                                                        .contains(toggleClass)))
                                            border.classList.toggle(toggleClass)
                                    }
                                })
                        }

                        const pauseVideos = () => videos
                            .filter(video => !video.paused
                                && video.readyState > 2)
                            .forEach(video => video.pause())

                        const playVideoAssets = () => videos
                            .filter((video) => {
                                if (!assets.contains(video)
                                        || !video.paused
                                        || video.readyState <= 2
                                        || !chapter.classList.contains('active'))
                                    return

                                const { bottom, top, viewport }
                                    = getBoundsInViewport(video)

                                return bottom
                                    || top
                                    || viewport
                            })
                            .forEach(video => video.play()
                                .catch(err => isDev
                                    && console.warn(err)))

                        const playCoverVideo = () => coverVideo
                            && coverVideo.paused
                            && coverVideo.readyState > 2
                            && coverVideo.play()
                                .catch(err => isDev
                                    && console.warn(err))

                        const onEnter = (self) => {
                            const direction = self.direction != -1
                                ? 'down'
                                : 'up'

                            if (isLast
                                    && direction === 'up')
                                return

                            fix(bg)
                            fix(cover)

                            if (!isDev)
                                return

                            console.groupCollapsed(`${isLast ? 'Last ' : ''}Chapter ${idx} Timeline - Start - Enter`)
                            console.log(self)
                            console.groupEnd()
                        }

                        const onLeave = (self) => {
                            unfix(cover)
                            unfix(bg)
                            pauseVideos()

                            if (captionToggle
                                    && captionToggle
                                        .getAttribute('aria-expanded')
                                            === 'true') {
                                const activeEl = document.activeElement

                                captionToggle.click()

                                if (document.activeElement !== activeEl)
                                    activeEl.focus({ preventScroll: true })
                            }

                            if (!isDev)
                                return

                            console.groupCollapsed(`${isLast ? 'Last ' : ''}Chapter ${idx} Timeline - Start - Leave`)
                            console.log(self)
                            console.groupEnd()
                        }

                        const tl = wrapper
                            && window.gsap.timeline({
                                scrollTrigger: {
                                    toggleActions: 'play pause reverse reset',
                                    toggleClass: 'active',
                                    trigger: chapter,
                                    start: 'top bottom',
                                    end:  'bottom top',
                                    scrub: true,
                                    invalidateOnRefresh: true,
                                    onEnter,
                                    onEnterBack: (self) => !isLast
                                        && onEnter(self),
                                    onUpdate: (self) => {
                                        const direction = self.direction != -1
                                            ? 'down'
                                            : 'up'

                                        if (chapter.getAttribute('data-direction')
                                                !== direction)
                                            chapter.setAttribute(
                                                'data-direction',
                                                direction)

                                        setBorders()

                                        if (self.isActive)
                                            playCoverVideo()

                                        if (self.isActive
                                                && bgTl.scrollTrigger.progress === 1
                                                && !isIOS)
                                            playVideoAssets()

                                        if (!init
                                                && self.isActive
                                                && !chapter.classList.contains('ready'))
                                            chapter.classList.add('ready')
                                    },
                                    onLeave,
                                    onLeaveBack: onLeave,
                                    onRefreshInit: (self) => {
                                        if (!init)
                                            chapter.classList.add('ready')
                                    }
                                }
                            })

                        const bgTl = bg
                            && window.gsap.timeline({
                                scrollTrigger: {
                                    toggleActions: 'play pause reverse reset',
                                    trigger: chapter,
                                    start: 'top bottom',
                                    end: 'top top',
                                    scrub: true,
                                    invalidateOnRefresh: true,
                                    onEnter: (self) => {
                                        if (!isDev)
                                            return

                                        console.groupCollapsed(`Chapter ${idx} Timeline - BG  - Enter`)
                                        console.log(self)
                                        console.groupEnd()
                                    },
                                    onUpdate: (self) => {
                                        if (self.progress === 1)
                                            setBorders()
                                    },
                                    onLeave: (self) => {
                                        if (!isDev)
                                            return

                                        console.groupCollapsed(`Chapter ${idx} Timeline - BG  - Leave`)
                                        console.log(self)
                                        console.groupEnd()
                                    },
                                    onLeaveBack: (self) => {
                                        setBorders()
                                    }
                                }
                            })

                        // Determine based on viewport size and text size,
                        // whether it should stick to the bottom
                        const onContentRefresh = () => {
                            if (!content)
                                return

                            const contentWidth = `${content.clientWidth}px`

                            const contentWidthVar = '--chapter-content-width'

                            if (getCssVar(contentWidthVar, content)
                                    !== contentWidth)
                                setCssVar(contentWidthVar, contentWidth, content)

                            const titleHeight = title
                                && `${(title.children[0] || {}).clientHeight}px`
                                    || 'auto'

                            const textHeight = text
                                && `${(text.children[0] || {}).clientHeight}px`
                                    || 'auto'

                            if (title) {
                                if (title.style.height !== titleHeight)
                                    title.style.height = titleHeight

                                if (title.style.minHeight !== titleHeight)
                                    title.style.minHeight = titleHeight
                            }

                            if (text) {
                                if (text.style.height !== textHeight)
                                    text.style.height = textHeight

                                if (text.style.minHeight !== textHeight)
                                    text.style.minHeight = textHeight
                            }

                            const offsetHeight = window.innerHeight
                                - getDrupalOffsetTop()
                                - (parseFloat(getCssVar(
                                    '--chapter-padding',
                                    chapter)) * 16 * 2)

                            const isSpacers = offsetHeight
                                >= ((title || {}).children[0] || {}).clientHeight
                                    + ((text || {}).children[0] || {}).clientHeight

                            if (!init
                                    && !content.getAttribute('data-spacers')
                                        !== String(isSpacers))
                                content.setAttribute('data-spacers', isSpacers)
                        }

                        const onContentScroll = (self) => {
                            const toggleClass = 'pin'

                            const isSpacers = content
                                .getAttribute('data-spacers')
                                    === 'true'

                            const spacerAttr = 'data-spacer'

                            const isActive = (self || {}).isActive
                                || chapter.classList.contains('active')

                            const offsetTop = getDrupalOffsetTop()
                                + (parseFloat(getCssVar(
                                    '--chapter-padding',
                                    chapter)) * 16)
                                + parseFloat(((title || {}).style || {}).height
                                    || 0)

                            const offsetTopSticky = offsetTop
                                +  (parseFloat(getCssVar(
                                    '--chapter-content-pin-offset-y',
                                    chapter)) * 16)

                            const titleBounds = title
                                && title.getBoundingClientRect()

                            if (title) {
                                const isPinned = title.classList
                                    .contains(toggleClass)

                                const isUnpinned =  title.classList
                                    .contains(`un${toggleClass}`)

                                let isTitleUnpin = false

                                if (isSpacers
                                        && text)
                                    isTitleUnpin = offsetTopSticky
                                        >= text.getBoundingClientRect().top

                                if (titleBounds.top - offsetTop <= 0
                                        && isActive
                                        && isSpacers
                                        && bgTl.scrollTrigger.progress === 1
                                        && !isTitleUnpin
                                        && !isPinned)
                                    title.classList.add(toggleClass)

                                if ((!isActive
                                            || !isSpacers
                                            || isTitleUnpin
                                            || titleBounds.top - offsetTop > 0
                                            || bgTl.scrollTrigger.progress !== 1)
                                        && isPinned)
                                    title.classList.remove(toggleClass)

                                if ((isTitleUnpin
                                            && !isUnpinned)
                                        || (!isTitleUnpin
                                            && isUnpinned))
                                    title.classList.toggle(`un${toggleClass}`)
                            }
                        }

                        const contentTl = content
                            && window.gsap.timeline({
                                scrollTrigger: {
                                    toggleActions: 'play pause reset',
                                    trigger: content,
                                    start: 'top bottom',
                                    end:  'bottom top',
                                    invalidateOnRefresh: true,
                                    onUpdate: (self) => {
                                        if (init)
                                            return

                                        const toggleClass = 'active'

                                        if ((self.isActive
                                                   && !content.classList
                                                        .contains(toggleClass))
                                                || (!self.isActive
                                                    && content.classList
                                                        .contains(toggleClass)))
                                            content.classList
                                                .toggle(toggleClass)

                                        onContentScroll(self)
                                    },
                                    onRefresh: () => {
                                        onContentRefresh()
                                        onContentScroll()
                                    }
                                }
                            })

                        const lastChildTl = isLast
                            && window.gsap.timeline({
                                scrollTrigger: {
                                    toggleActions: 'play pause reverse reset',
                                    trigger: chapter,
                                    start: (self) => {
                                        const bottomOffset =
                                            getCssVar(
                                                '--chapter-padding-bottom',
                                                chapter) || '0'

                                        return `bottom bottom-=${bottomOffset}`
                                    },
                                    end: 'bottom top',
                                    scrub: true,
                                    invalidateOnRefresh: true,
                                    onUpdate: (self) => {
                                        if (init
                                                || !content)
                                            return

                                        const { bottom, top, viewport, bounds }
                                            = getBoundsInViewport(wrapper)

                                        if (bottom
                                                && !top
                                                && !content.classList
                                                    .contains('bottom'))
                                            content.classList.add('bottom')
                                    },
                                    onEnter: (self) => {
                                        if (bgTl)
                                            bgTl.pause()

                                        playCoverVideo()

                                        unfix(bg)
                                        unfix(cover)
                                        setBorders()

                                        if (!isDev)
                                            return

                                        console.groupCollapsed(`Last child - Chapter ${idx} Timeline - Enter`)
                                        console.log(self)
                                        console.groupEnd()
                                    },
                                    onEnterBack: (self) => {
                                        if (content
                                                && !content.classList.contains('bottom'))
                                            content.classList.add('bottom')

                                        if (!isDev)
                                            return

                                        console.groupCollapsed(`Last child - Chapter ${idx} Timeline - EnterBack`)
                                        console.log(self)
                                        console.groupEnd()
                                    },
                                    onLeave: (self) => {
                                        if (content
                                                && !content.classList.contains('bottom'))
                                            content.classList.add('bottom')

                                        if (!isDev)
                                            return

                                        console.groupCollapsed(`Last child - Chapter ${idx} Timeline - Leave`)
                                        console.log(self)
                                        console.groupEnd()
                                    },
                                    onLeaveBack: () => {
                                        if (content
                                                && content.classList.contains('bottom'))
                                            content.classList.remove('bottom')

                                        if (bgTl)
                                            bgTl.pause()

                                        playCoverVideo()
                                        fix(bg)
                                        fix(cover)
                                        setBorders()

                                        if (!isDev)
                                            return

                                        console.groupCollapsed(`Last child - Chapter ${idx} Timeline - LeaveBack`)
                                        console.log(self)
                                        console.groupEnd()
                                    }
                                }
                            })

                        videos
                            .forEach((video) => {
                                video.removeAttribute('autoplay')
                                video.load()
                            })

                        pauseVideos()

                        if (bg)
                            window.gsap.set(bg, {
                                autoAlpha: 0
                            })

                        if (cover)
                            window.gsap.set(cover, {
                                scale: window.innerWidth
                                    / (window.innerWidth
                                        - (parseFloat(getCssVar(
                                            '--chapter-padding',
                                            chapter)) * 16 * 2)),
                                yPercent: 100
                            })

                         if (bgTl) {
                            bgTl.to(bg, {
                                autoAlpha: 1
                            })

                            if (cover)
                                bgTl.to(cover, {
                                    scale: 1,
                                    visibility: 'visible',
                                    yPercent: 0
                                })
                        }

                        // Catch-all edge cases
                        window.addEventListener('scroll', () => {
                            setBorders()
                            onContentScroll()
                        }, {
                            passive: true
                        })

                        window.addEventListener('resize', () => {
                            onContentRefresh()
                            onContentScroll()
                        })

                        window.addEventListener('load', () => {
                            setTimeout(() => !isIOS
                                && playVideoAssets(), 17)
                        })

                        return [tl, bgTl, contentTl, lastChildTl]
                            .filter(obj => obj)
                    }))
                .reduce((acc, curr) => acc.concat(curr), [])
            .filter(tl => Array.isArray(tl))
            .reduce((acc, curr) => acc.concat(curr), [])
    }

    function gsapTextForm() {
        const el = document.querySelector('.text-form')

        if (!el)
            return

        const cols = window.gsap.utils.toArray('.text-form-col')

        window.gsap.set(cols, {
            opacity: 0,
            yPercent: 50
        })

        const tl = window.gsap.timeline({
            scrollTrigger: {
                toggleActions: 'play complete pause reverse',
                trigger: el,
                start: 'top 75%',
                end: 'bottom top',
                invalidateOnRefresh: true
            },
        })

        tl
            .to (cols, {
                duration: 0.3,
                opacity: 1,
                stagger: 0.2,
                yPercent: 0,
            })

        return tl
    }

    function gsapFunnels() {
        const el = document.querySelector('.content-funnels')

        if (!el)
            return

        const cols = window.gsap.utils.toArray('.content-funnels-item')

        window.gsap.set(cols, {
            opacity: 0,
            y: '30px'
        })

        const tl = window.gsap.timeline({
            scrollTrigger: {
                toggleActions: 'play complete pause reverse',
                trigger: el,
                start: 'top 75%',
                end: 'bottom top',
                invalidateOnRefresh: true
            },
        })

        tl
            .to (cols, {
                duration: 0.5,
                opacity: 1,
                stagger: 0.25,
                y: 0,
            })

        return tl
    }

    function gsapFunnelCards() {
        const els =  window.gsap.utils.toArray('.funnel-cards')

        els.forEach((el, i) => {
            const items = window.gsap.utils.toArray(el
                .querySelectorAll('.funnel-cards-item'))

            const content = window.gsap.utils.toArray(el
                .querySelectorAll('.funnel-cards-item-content'))

            const mm = window.gsap.matchMedia()

            mm.add(`(min-width: ${mobileMax}px)`, () => {
                const tl = window.gsap.timeline({
                    scrollTrigger: {
                        toggleActions: 'play complete pause reverse',
                        trigger: el,
                        start: 'top 35%',
                        invalidateOnRefresh: true
                    },
                })

                if (items)
                    tl.to(items, {
                        duration: .75,
                        rotate: 0,
                        scale: 1,
                        x: 0,
                        y: 0,
                        ease: 'power2.inOut'
                    })

                if (content)
                    tl.to(content, {
                        opacity: 1,
                        ease: 'power2.inOut'
                    }, '<0.1')
            })
        })
    }

    function gsapCallout() {
        const els =  window.gsap.utils.toArray('.callout')

        els.forEach((el, i) => {
            const text = el
                .querySelector('.callout-content-text')

            window.gsap.matchMedia().add(`(min-width: ${mobileMax}px)`, () => {
                const tl = window.gsap.timeline({
                    scrollTrigger: {
                        toggleActions: 'play complete pause reverse',
                        trigger: el,
                        start: 'top 50%',
                        invalidateOnRefresh: true,
                        onEnter: (self) => !el.classList.contains('animate')
                            && el.classList.add('animate'),
                        onLeaveBack: (self) => el.classList.contains('animate')
                            && el.classList.remove('animate'),
                    }
                })

                if (text)
                    tl.to(text, {
                        duration: 1,
                        opacity: 1,
                    }, '<0.1')
            })
        })
    }

    function gsapCarousel() {
        const els = window.gsap.utils.toArray('.carousel')

        return els.forEach((el, i) => {
            const splideEl = el.querySelector('.splide')

            const carouselSplide = splide
                && window.Splide
                && window.splide.Extensions
                && new window.Splide(splideEl, {
                    type: 'loop',
                    drag: 'free',
                    autoplay: false,
                    autoScroll: {
                        speed: 1
                    },
                    autoWidth: true,
                    arrows: false,
                    focus: 0,
                    pagination: false,
                    isNavigation: false,
                    mediaQuery: 'min'
                })

            if (carouselSplide)
                carouselSplide.mount(window.splide.Extensions)

            const coverBoundsEl = el.nextElementSibling
                    && el.nextElementSibling.classList.contains('statement')
                    && !el.nextElementSibling.classList.contains('statement-xl')
                ? el.nextElementSibling
                : el

            const tl = window.gsap.timeline({
                scrollTrigger: {
                    trigger: el,
                    start: 'top bottom',
                    endTrigger: coverBoundsEl,
                    invalidateOnRefresh: true,
                    onUpdate: (self) => {
                        const coverVideo = el
                            .querySelector('.carousel-cover video')

                        const bounds = getBoundsInViewport(el)

                        const isActive = bounds.viewport

                        const coverBounds = coverBoundsEl === el
                            ? bounds
                            : getBoundsInViewport(coverBoundsEl)

                        let isCoverActive = coverVideo
                            && (isActive
                                || coverBounds.top)

                        if (isCoverActive
                                && coverBoundsEl !== el)
                            isCoverActive = coverBounds.bounds.bottom
                                >= window.innerHeight * 0.5

                        if (coverVideo
                                && isCoverActive
                                && coverVideo.paused)
                            coverVideo.play()
                                .catch(err => isDev
                                    && console.warn(err))

                        if (coverVideo
                                && !isCoverActive
                                && !coverVideo.paused)
                            coverVideo.pause()

                        if ((isCoverActive
                                    && !coverVideo.parentElement.classList
                                        .contains('active'))
                                || (!isCoverActive
                                    && coverVideo
                                    && coverVideo.parentElement.classList
                                        .contains('active')))
                            coverVideo.parentElement.classList
                                .toggle('active')

                        if ((isActive
                                    && !el.classList.contains('active'))
                                || (!isActive
                                    && el.classList.contains('active')))
                            el.classList.toggle('active')

                        if (!carouselSplide
                                || !carouselSplide.root.classList
                                    .contains('is-active'))
                            return

                        const {
                            isPaused,
                            pause,
                            play
                        } = carouselSplide.Components.AutoScroll

                        if (!isActive
                                && !isPaused())
                            pause()

                        if (isActive
                                && isPaused())
                            play()
                    }
                },
            })

            return tl
        })
    }

    function gsapCountUp() {
        const el = document
            .querySelector('.paragraph--type--50th-anniversary-countdown')

        if (!el
            || !window.countUp)
            return

        const classes = ['days', 'hours', 'mins']

        const countupEls = []

        const countupOptions = {
            duration: 3
        }

        const els = el
            .querySelectorAll('time span')

        const datetimeEls = Array.from(els)
            .filter(e => classes
                .some(className => e.classList
                    .contains(className)))

        if (datetimeEls)
            datetimeEls.forEach(e => {
                countupEls
                    .push(new window.countUp.CountUp(e,
                        +e.innerHTML || 0,
                        countupOptions))
            })

        if (countupEls)
            window.ScrollTrigger.create({
                trigger: el
                    .querySelector('.statement-copy'),
                start: 'top bottom',
                onEnter: () => {
                    countupEls
                        .forEach(e => e.start())
                }
            })
    }

    function filters () {
        const els = window.gsap.utils.toArray('nav.filters')

        els.forEach((el, i) => {
            window.ScrollTrigger.create({
                trigger: el,
                start: 'top bottom',
                endTrigger: el.parentElement,
                end: 'bottom top',
                toggleClass: 'active',
                invalidateOnRefresh: true
            })

            const dropdowns = window.gsap.utils
                .toArray(el.querySelectorAll('.dropdown'))

            const clearBtns = window.gsap.utils
                .toArray(el.querySelectorAll('.filters-group-clear'))

            // TODO window.history form states
            el.addEventListener('change', (e) => {
                const dropdown = dropdowns
                    .filter(_el => _el.contains(e.target))[0]

                const clearBtn = dropdown
                    && dropdown.querySelector('.filters-group-clear')

                const clearBtnText = clearBtn
                    && clearBtn.querySelector('.filters-group-clear-text')

                if (!clearBtnText)
                    return

                clearBtnText.innerHTML = e.target.nextElementSibling
                    .textContent

                clearBtn.setAttribute('aria-label', `Clear "${
                    clearBtnText.textContent}" ${
                    ((clearBtn.nextElementSibling || {}).textContent || '')
                        .trim()} filter`)

                clearBtn.classList.add('active')
            })

            clearBtns
                .forEach((clearBtn) => {
                    clearBtn.addEventListener('click', (e) => {
                        const checked = window.gsap.utils.toArray(
                            clearBtn.parentElement
                                .querySelectorAll('input:checked'))

                        checked.forEach(input => {
                            input.checked = false

                            input.dispatchEvent(new CustomEvent('change', {
                                detail: e,
                                bubbles: true
                            }))
                        })

                        clearBtn.classList.remove('active')
                    })
                })
        })
    }

    function onReady () {
        if (!init)
            return

        init = false

        document.body.style.minHeight = ''

        document.body.style.opacity = 1

        document.documentElement.setAttribute('data-ready', true)

        window.addEventListener('resize',
            debounce(() => window.ScrollTrigger.refresh(), 200))
    }

    function start() {
        gsapIntro()
        gsapCarousel()
        gsapBooks()
        gsapStatement()
        gsapTextForm()
        gsapTimeline()
        gsapMoments()
        gsapFunnels()
        gsapFunnelCards()
        gsapCallout()
        gsapCountUp()

        filters()
        progressBar()

        const observer = new window.MutationObserver(() => {
            const intro = getGsapIntroEl()

            const isReady = !intro
                || (intro.parentElement.classList.contains('pin-spacer')
                    && intro.parentElement.clientHeight >=
                        window.innerHeight * 2)

            if (!isReady)
                return

            observer.disconnect()

            onReady()
        })

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true
        })
    }

    start()
})()
